<template>
  <div class="service">
    <i :class="`service__icon sm rhg-font-icon--${service.code}`"></i>
    <span class="service__name">{{ service.name }}</span>
  </div>
</template>

<script>
import RoomService from '../../domain/RoomService'

export default {
  name: 'ServiceComponent',
  props: {
    service: {
      type: RoomService
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 64px;

  &__name {
    margin-top: 0.5rem;
    text-align: center;
    line-height: 1rem;
    font-size: 9px;
  }
}
</style>
